import {
  SovosButton,
  SovosMenuItem,
  SovosGrid,
  SovosTextField,
} from "mosaic-react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useRef, useState } from "react";
import { oseFields } from "../utils/oseFields";
import { docTypes } from "../utils/docTypes";
import { fiscal } from "../utils/fiscal";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import ReCAPTCHA from "react-google-recaptcha";
import { verifyCaptchaToken } from "../api/verifyCaptchaToken";
import dayjs from "dayjs";
import Text from "./typography/Text";

function RequestForm({ onSubmit }) {
  const [searchClick, setSearchClick] = useState(false);
  const [formData, setFormData] = useState({
    issuerId: "",
    receiptType: "",
    documentType: "",
    receiverId: "",
    correlative: "",
    issueDate: null,
    total: "",
    captcha: "",
  });

  const [formErrors, setFormErrors] = useState({
    issuerId: { error: false, message: "" },
    receiptType: { error: false, message: "" },
    documentType: { error: false, message: "" },
    receiverId: { error: false, message: "" },
    correlative: { error: false, message: "" },
    issueDate: { error: false, message: "" },
    total: { error: false, message: "" },
    captcha: { error: false, message: "" },
  });

  const captcha = useRef(null);
  const validateForm = () => {
    const updatedFormErrors = Object.keys(formData).reduce((acc, field) => {
      if (formData[field] === "" && requiredFields.includes(field)) {
        acc[field] = { error: true, message: "Campo obligatorio" };
      } else {
        acc[field] = {
          error: formErrors[field].error,
          message: formErrors[field].message,
        };
      }
      return acc;
    }, {});

    setFormErrors({ ...formErrors, ...updatedFormErrors });
  };

  useEffect(() => {
    validateForm();
    // eslint-disable-next-line
  }, [formData]);

  const requiredFields = [
    "issuerId",
    "receiptType",
    "correlative",
    "issueDate",
    "captcha",
  ];

  const handleIssuerId = (event) => {
    const issuerId = event.target.value;
    setFormData({ ...formData, issuerId: issuerId });
    validateField("issuerId", issuerId);
  };

  const handleReceiptType = (event) => {
    const receiptType = event.target.value;
    setFormData({ ...formData, receiptType: receiptType });
    validateField("receiptType", receiptType);
  };

  const handleDocumentType = (event) => {
    const documentType = event.target.value;
    setFormData({ ...formData, documentType: documentType });
  };

  const handleReceiverId = (event) => {
    const receiverId = event.target.value;
    setFormData({ ...formData, receiverId: receiverId });
  };

  const handleCorrelative = (event) => {
    const correlative = event.target.value;
    setFormData({ ...formData, correlative: correlative });
    validateField("correlative", correlative);
  };

  const handleIssueDate = (event) => {
    const issueDate = event;
    setFormData({
      ...formData,
      issueDate: issueDate,
    });
    validateField("issueDate", issueDate);
  };

  const handleTotal = (event) => {
    const total = event.target.value;
    setFormData({ ...formData, total: total });
    validateField("total", total);
  };

  const handleCaptchaToken = (event) => {
    const captchaToken = captcha.current.getValue();
    setFormData({ ...formData, captcha: captchaToken });
    validateField("captcha", captchaToken);
  };

  function checkDocumentTypeAndReceiverId() {
    if (fiscal.includes(formData.receiptType)) {
      return {
        issuerId: formData.issuerId,
        receiptType: formData.receiptType,
        documentType: "-",
        correlative: formData.correlative,
        issueDate: formData.issueDate,
        total: formData.total,
      };
    } else {
      return formData;
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const filteredForm = checkDocumentTypeAndReceiverId();
    const date = dayjs(formData.issueDate).format("DD/MM/YYYY");
    const correlative = getCorrelative(formData.correlative, 1);
    const serie = getCorrelative(formData.correlative, 0);

    const request = makeRequestObject(filteredForm, date, correlative, serie);

    const hasErrors = Object.values(formErrors).some(
      (field) => field.error === true
    );

    if (!hasErrors) {
      setSearchClick(true);
      onSubmit(request);
    }
  };

  function getCorrelative(string, index) {
    const parts = string.split("-");
    return parts[index];
  }

  function makeRequestObject(filteredForm, date, correlative, serie) {
    const request = Object.assign({}, filteredForm, {
      issueDate: date,
      correlative,
      serie,
    });

    delete request.captcha;
    return request;
  }
  function validateField(fieldName, value) {
    switch (fieldName) {
      case "issuerId":
        const issuerIdErrors = {
          error: false,
          message: "",
        };

        const issuerIdRegex = /\b[0-9]{11}\b/;
        if (!issuerIdRegex.test(value)) {
          issuerIdErrors.error = true;
          issuerIdErrors.message = "Numérico longitud 11";
        }
        setFormErrors({ ...formErrors, issuerId: issuerIdErrors });
        break;
      case "receiptType":
        const receiptTypeErrors = {
          error: false,
          message: "",
        };
        if (value === "") {
          receiptTypeErrors.error = true;
          receiptTypeErrors.message = "Por favor, ingrese una fecha válida";
        }
        setFormErrors({ ...formErrors, receiptType: receiptTypeErrors });
        break;
      case "correlative":
        const correlativeErrors = {
          error: false,
          message: "",
        };

        const correlativeRegex = /\b[a-zA-Z0-9]{4}-[0-9]/;
        if (!correlativeRegex.test(value)) {
          correlativeErrors.error = true;
          correlativeErrors.message = "Formato invalido";
        }
        setFormErrors({ ...formErrors, correlative: correlativeErrors });
        break;
      case "issueDate":
        const issueDateErrors = {
          error: false,
          message: "",
        };
        if (value === "Invalid Date") {
          issueDateErrors.error = true;
          issueDateErrors.message = "Por favor, ingrese una fecha válida";
        }
        setFormErrors({ ...formErrors, issueDate: issueDateErrors });
        break;

      case "total":
        const totalErrors = {
          error: false,
          message: "",
        };
        const totalRegex = /^[0-9]+(.[0-9]{1,5})?$/;
        if (!totalRegex.test(value) && value !== "") {
          totalErrors.error = true;
          totalErrors.message = "Por favor, ingrese un valor numérico válido";
        }
        setFormErrors({ ...formErrors, total: totalErrors });
        break;
      case "captcha":
        const captchaErrors = {
          error: false,
          message: "",
        };
        verifyCaptchaToken(value)
          .then((response) => {})
          .catch((error) => {
            captchaErrors.error = true;
            captchaErrors.message = "Por favor, valide el captcha";
          });
        setFormErrors({ ...formErrors, captcha: captchaErrors });
        break;
      default:
        break;
    }
  }

  const clearData = (event) => {
    setFormData({
      issuerId: "",
      receiptType: "",
      documentType: "",
      receiverId: "",
      correlative: "",
      issueDate: null,
      total: "",
    });
  };

  return (
    <form noValidate onSubmit={handleSubmit}>
      <SovosGrid
        container
        alignItems="center"
        sx={{ paddingLeft: "1rem", paddingTop: "1rem" }}
      >
        {/* IssuerId */}
        <SovosGrid item xs={12} sm={4}>
          <Text title="Número de RUC del emisor:" isRequired={true} />
        </SovosGrid>
        <SovosGrid item xs={12} sm={8}>
          <SovosTextField
            id={"issuer_id"}
            placeholder="ej: 96372362736"
            multiline
            onChange={handleIssuerId}
            value={formData.issuerId}
            error={formErrors.issuerId.error}
            helperText={
              formErrors.issuerId.error && formErrors.issuerId.message
            }
            sx={{ width: "15rem" }}
          />
        </SovosGrid>

        {/*/!* ReceiptType *!/*/}
        <SovosGrid item xs={12} sm={4} sx={{ paddingTop: "1rem" }}>
          <Text title="Tipo de comprobante:" isRequired={true} />
        </SovosGrid>
        <SovosGrid item xs={12} sm={8}>
          <SovosTextField
            id={"receipt_type"}
            select
            value={formData.receiptType}
            onChange={handleReceiptType}
            sx={{ width: "15rem" }}
            label={" "}
          >
            {oseFields.map((x, idx) => (
              <SovosMenuItem key={idx} value={x.value} id={x.label}>
                {x.label}
              </SovosMenuItem>
            ))}
          </SovosTextField>
        </SovosGrid>
        {/*/!*DocumentType*!/*/}
        {!fiscal.includes(formData.receiptType) && (
          <SovosGrid item xs={12} sm={4} sx={{ paddingTop: "1rem" }}>
            <Text
              title="Tipo de Documento de Identidad del Receptor:"
              isRequired={false}
            />
          </SovosGrid>
        )}
        {!fiscal.includes(formData.receiptType) && (
          <SovosGrid item xs={12} sm={8}>
            <SovosTextField
              id={"document_type"}
              select
              value={formData.documentType}
              onChange={handleDocumentType}
              sx={{ width: "15rem" }}
              label={" "}
            >
              {docTypes.map((x) => (
                <SovosMenuItem key={x.value} value={x.value} id={x.value}>
                  {x.label}
                </SovosMenuItem>
              ))}
            </SovosTextField>
          </SovosGrid>
        )}
        {/*/!*ReceiverId*!/*/}
        <SovosGrid item xs={12} sm={4} sx={{ paddingTop: "1rem" }}>
          <Text
            title="Número Documento de Identidad del Receptor:"
            isRequired={true}
          />
        </SovosGrid>
        <SovosGrid item xs={12} sm={8}>
          <SovosTextField
            id={"receiver_id"}
            placeholder="ej: 83327364728"
            multiline
            onChange={handleReceiverId}
            value={formData.receiverId}
            sx={{ width: "15rem" }}
          />
        </SovosGrid>
        {/*/!* Correlative *!/*/}
        <SovosGrid item xs={12} sm={4} sx={{ paddingTop: "1rem" }}>
          <Text title="Número del comprobante:" isRequired={true} />
        </SovosGrid>
        <SovosGrid item xs={12} sm={8}>
          <SovosTextField
            id={"correlative"}
            multiline
            onChange={handleCorrelative}
            value={formData.correlative}
            error={formErrors.correlative.error}
            placeholder="ej: 1234-56"
            helperText={
              formErrors.correlative.error && formErrors.correlative.message
            }
            sx={{ width: "15rem" }}
          />
        </SovosGrid>
        {/*/!* IssueDate *!/*/}
        <SovosGrid item xs={12} sm={4} sx={{ paddingTop: "1rem" }}>
          <Text title="Fecha del comprobante:" isRequired={true} />
        </SovosGrid>
        <SovosGrid item xs={12} sm={8} sx={{ paddingTop: "1rem" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DesktopDatePicker
              disableFuture={true}
              inputFormat="DD/MM/YYYY"
              label={"dd/mm/yyyy"}
              value={formData.issueDate}
              onChange={handleIssueDate}
              renderInput={(params) => (
                <SovosTextField
                  id={"issue_date"}
                  variant="filled"
                  helperText={null}
                  {...params}
                />
              )}
            />
          </LocalizationProvider>
        </SovosGrid>
        {/*/!* Total *!/*/}
        <SovosGrid item xs={12} sm={4} sx={{ paddingTop: "1rem" }}>
          <Text title="Importe total:" isRequired={true} />
        </SovosGrid>
        <SovosGrid item xs={12} sm={8}>
          <SovosTextField
            id={"total"}
            placeholder="ej: 5619.90"
            inputProps={{
              type: "number",
              min: 0,
              step: 1,
            }}
            type="number"
            multiline
            onChange={handleTotal}
            value={formData.total}
            error={formErrors.total.error}
            helperText={formErrors.total.error && formErrors.total.message}
            sx={{ width: "15rem" }}
          />
        </SovosGrid>
        {/* Captcha */}
        <SovosGrid item xs={12} sm={4} sx={{ paddingTop: "1rem" }}>
          <Text title="Captcha:" isRequired={true} />
        </SovosGrid>
        <SovosGrid item xs={12} sm={8} sx={{ paddingTop: "1rem" }}>
          <ReCAPTCHA
            ref={captcha}
            size="normal"
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={handleCaptchaToken}
          />
        </SovosGrid>

        {/*Buttons*/}
        <SovosGrid item xs={12} sm={4} sx={{ paddingTop: "2rem" }}></SovosGrid>
        <SovosGrid
          item
          xs={12}
          sm={8}
          sx={{ paddingTop: "2rem", paddingBottom: "2rem" }}
        >
          <SovosButton
            id={"search_button"}
            sx={{ marginRight: "10px" }}
            type="submit"
            variant="contained"
            disabled={searchClick}
          >
            Buscar
          </SovosButton>
          <SovosButton
            id={"clear_button"}
            variant="contained"
            onClick={clearData}
            disabled={searchClick}
          >
            Cancelar
          </SovosButton>
        </SovosGrid>
      </SovosGrid>
    </form>
  );
}

export default RequestForm;
